var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adInfo.extra && _vm.adInfo.extra.couponInfo)?_c('ShareCouponSmall',{attrs:{"couponInfo":_vm.adInfo.extra.couponInfo},on:{"onClick":_vm.handleClickAd}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }